const mutations = {};

/**
 * 로그인 여부 저장
 * @param {*} state
 * @param {isLogin} isLogin
 */
mutations.SET_IS_LOGIN = (state, isLogin) => {
  state.isLogin = isLogin;
};

/**
 * Point 종류
 * @param {*} state
 * @param {value} value - value 정보
 */
mutations.SET_SERVICEINFO = (state, value) => {
  state.serviceUrl = value?.pathKey;
  state.serviceInfo = value;
};

mutations.SET_SERVICEURL = (state, value) => {
  state.serviceUrl = value;
};

// pointThumbnailList
mutations.SET_POINT_THUMBNAIL_LIST = (state, value) => {
  state.pointThumbnailList = value;
};

// point list
mutations.SET_POINTLIST = (state, value) => {
  state.pointList = value;
};

/**
 * Point 전환 레이어 URL
 * @param {*} state
 * @param {isLogin} isLogin
 */
mutations.SET_EXCHANGELAYERURL = (state, value) => {
  state.exchangeLayerUrl = value;
};

/**
 * Point 전환 아이프레임 여부
 * @param {*} state
 * @param {isLogin} isLogin
 */
mutations.SET_EXCHANGEIFRAME = (state, value) => {
  state.isExchangeIframe = value;
};

export default {
  ...mutations,
};
